// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1__jE","cls2":"CreateSocialItem-cls2_AeO CreateSocialItem-cls1__jE"};